const cache = {}

const getItem = (key) => (cache[key])

const setItem = (key, value) => {
    cache[key] = value
}

const removeItem = (key) => { delete cache[key] }

export default {
    getItem, setItem, removeItem
}